import { GridCol } from "../components/table/TableList";
import { User } from "../model/Users";

export class UserSelect {
  main = () => {};

  // 配信先利用者選択モーダルカラム
  userFormColumns: GridCol[] = [
    { field: "check", headerName: '', style: "w-max-12", },
    { field: "name", headerName: "名前", style: "", },
  ];

  // 配信先利用者選択モーダルデータ
  userListRow = (
    filteredUserList: User[],
    onSelectToken: (e: React.ChangeEvent<HTMLInputElement>, id: string) => void,
    tokenState: string[]
  ) => {
    return filteredUserList?.map((user) => {
    const userName = user.lastName !== '' && user.lastName !== undefined ? user.lastName : '未登録';
    return {
      rowData: {
        check: (
          <input
            id={`token-${user.id}`}
            aria-describedby="token-description"
            name={`token-${user.id}`}
            type="checkbox"
            className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-500"
            data-id={user.id}
            data-category={"token"}
            onChange={(e) => onSelectToken(e, user.id)}
            checked={tokenState.includes(user.id)}
          />
        ),
        name: `${userName}`,
        explanation: "",
        usersCount: "",
      }
    }
  }) ?? []};

  // 配信先利用者検索
  search = (e: any, userList: User[], setFilteredUserList: React.Dispatch<React.SetStateAction<User[]>>) => {
    const regex = new RegExp(e.target.value);
    const baseFilteredUserList = userList.filter((user) => user.lastName !== undefined && user.lastName !== '' && !user.deleteFlg && !user.accountSuspensionFlg);
    if(e.target.value.length > 1){
      const filteredUserList = baseFilteredUserList.filter((user) => user.lastName?.match(regex) || user.lastNameKana?.match(regex));
      setFilteredUserList(filteredUserList);
    } else {
      setFilteredUserList(baseFilteredUserList);
    }
  };

  // 利用者選択モーダルで選択されたステートを更新
  userCheckedId = (
    e: React.ChangeEvent<HTMLInputElement>,
    id: string,
    userCheckedIdList: string[],
    setUserCheckedIdList: React.Dispatch<React.SetStateAction<string[]>>,
  ) => {
    if(e.target.checked){
      userCheckedIdList.push(id);
      setUserCheckedIdList([...new Set(userCheckedIdList.sort((a, b) => Number(a) - Number(b)))]);
    } else {
      const filter = userCheckedIdList.filter((checkedId) => checkedId !== id );
      setUserCheckedIdList([...new Set(filter.sort((a, b) => Number(a) - Number(b)))]);
    }
  }
}